import { render } from "./favourite-section.vue?vue&type=template&id=a06c2a08"
import script from "./favourite-section.vue?vue&type=script&lang=js"
export * from "./favourite-section.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__